import React from 'react';
import ExpertisePill from '../../Utils/ExpertisePill';

const Expertise = ({ expertise }) => {
  // Only render if expertise exists and has items
  if (!expertise?.items || expertise.items.length === 0) {
    return null;
  }

  return (
    <div className="bg-white rounded-lg shadow" style={{ overflow: 'visible', borderRadius: '0.5rem' }}>
      <div className="px-6 py-4">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Areas of Expertise</h3>
        <div className="flex flex-wrap gap-2">
          {expertise.items.map((item, index) => (
            <ExpertisePill
              key={index}
              name={item.expertise}
              title={item.rationale || "No rationale provided"}
              context={item.context}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Expertise;
